<div class="ui-g ui-g-nopad hidefilter-pos">
  <div class="ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad">
    <div class="float-right">
      <p-checkbox class="padding-0" value="0" binary="true" (onChange)="hideFilter($event)">
      </p-checkbox>
      <span class="hidefilter-txt" translate> label_map_view_hide_filter</span>
    </div>
  </div>
</div>
<div class="containar-layout manage-shift-container" *ngIf="!hideFilterSection">
  <div class="ui-g">
    <div class="ui-g-12 grid-wrap">
      <div class="ui-grid-left manage-shift-filters">
        <div class="form-field ui-g-12 ui-md-12 ui-lg-2">
          <div class="form-label">
            <label for="driverAvailability" translate></label>
          </div>
          <div class="form-control-c">
            <input autocomplete="off" type="text" pInputText [(ngModel)]="searchedTeam" (keyup)="searchTeam()"
              [placeholder]="'label_search_team' | translate" />
          </div>
        </div>

        <div class="form-field ui-g-12 ui-md-4 ui-lg-2 mb-w" *ngIf="!disableProvider">
          <div class="form-label">
            <label for="availability" translate>label_driver</label>
          </div>
          <div class="form-control-c">
            <p-dropdown [options]="providerList" [(ngModel)]="provider" (onChange)="onProviderChange()"
              [placeholder]="'label_all' | translate"  [style]="{'width': '100%'}">
            </p-dropdown>
          </div>
        </div>

        <div class="form-field ui-g-12 ui-md-4 ui-lg-2 mb-w">
          <div class="form-label">
            <label translate>label_service_region</label>
          </div>
          <div class="form-control-c">
            <p-multiSelect autocomplete="off" [options]="serviceRegionList"
              [defaultLabel]="'label_all' | translate" [style]="{'width': '100%'}"
              [(ngModel)]="selectedServiceRegionIds" filter="filter" [resetFilterOnHide]="true"
              (onChange)="changeFilter()">
            </p-multiSelect>
          </div>
        </div>

        <div class="form-field ui-g-12 ui-md-4 ui-lg-2">
          <div class="form-label">
            <label for="driverAvailability" translate>label_date</label>
          </div>
          <div class="form-control-c">
            <p-calendar [showIcon]="true" [(ngModel)]="date" (onSelect)="changeFilter()" [maxDate]="maxDate"
              [placeholder]="'label_date' | translate">
            </p-calendar>
          </div>
        </div>

        <div class="form-field ui-g-12 ui-md-4 ui-lg-2">
          <div class="form-label">
            <label for="driverAvailability" translate>label_user_type</label>
          </div>
          <div class="form-control-c">
            <p-dropdown [style]="{'width': '100%'}" [options]="userList" [(ngModel)]="selectedUserType"
              (onChange)="changeFilter()" [disabled]="disableProvider">
            </p-dropdown>
          </div>
        </div>

        <div class="form-field ui-g-12 ui-md-4 ui-lg-2">
          <div class="form-label">
            <label for="provider" translate>label_status</label>
          </div>
          <div class="form-control-c">
            <p-dropdown [options]="statusList" [(ngModel)]="selectedStatus" [resetFilterOnHide]="true"
              (onChange)="changeFilter()">
            </p-dropdown>
          </div>
        </div>
      </div>
      <div class="ui-grid-right">
        <div class="ui-right-block" *ngFor="let openShiftStatus of openShiftStatusList"><span class="rect-block"
            [ngClass]="openShiftStatusColors[openShiftStatus.value]"></span><span
            class="rect-text">{{openShiftStatus?.label}}</span></div>
      </div>
    </div>
  </div>
  <div class="ui-g">
    <div class="ui-g-12 grid-wrap">
      <div class="ui-grid-left">
        <div class="form-field ui-g-12 ui-md-12 ui-lg-12">
          <div class="display-buttons">
            <i class='fa fa-refresh reste-btn' [class.disabled]="!selectedUserType && !isDateChanged && !selectedStatus && !provider && !selectedServiceRegionIds.length" (click)="onResetFilter()"></i>
            <button pButton type="button" [label]="'Save Filter' | translate" [disabled]="!selectedUserType && !isDateChanged && !selectedStatus && !provider && !selectedServiceRegionIds.length" (click)="saveFilter()"></button>
            <button *ngIf="globalConfigOS && !organizationLevelDispatch" class="refresh-btn" pButton (click)="openShift()" type="button"
              [label]="'label_open_shift' | translate" pButton></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="containar-layout">
  <div class="table-section">
    <div class="column-wrapper" *ngFor="let shiftDetail of shiftDetails; let i = index">
      <div class="column-head" [class.custom-border]="i === 0">{{shiftDetail.dateStr | weekMonthDate }}</div>
      <div class="column-body">
        <div class="card-wrapper" *ngFor="let openShift of shiftDetail.openShiftList"
          (click)="openTeamPopup(openShift)">
          <app-manage-shift-slot-card [teamDetails]="openShift" [openShiftStatusList]="openShiftStatusList">
          </app-manage-shift-slot-card>
        </div>
        <div class="no-cards-wrapper" *ngIf="!shiftDetail.openShiftList.length">
          <span translate>label_no_text</span>
          <span translate>label_open_text</span>
          <span translate>label_shift_text</span>
          <span translate>label_published_text</span>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog [blockScroll]="true" modal="true" [showHeader]="false" position="center" responsive="true"
  [style]="{width: '450px', height: 'auto'}" styleClass="add-routes-popup" [(visible)]="hasShowPublishShiftPopUp"
  responsive="true" ng-style="overflow: auto" [contentStyle]="{'overflow':'auto'}">
  <app-publish-open-shift (publishOpenShiftEmitter)="onClickOfPopupButton($event)" [style]="{height: '500px',display: 'block'}"></app-publish-open-shift>
</p-dialog>

<p-dialog class="pop-shift" [blockScroll]="true" modal="true" [showHeader]="false" position="center" responsive="true"
  [style]="{width: '950px', height: 'auto'}" styleClass="add-routes-popup" [(visible)]="hasShowOpenShiftPopUp"
  responsive="true" ng-style="overflow: auto" [contentStyle]="{'overflow':'auto'}">
  <app-open-shift-pop *ngIf="hasShowOpenShiftPopUp" [openshiftIDs]="openShiftId" [openshiftStatusId]="openShiftStatus"></app-open-shift-pop>
</p-dialog>
